module.exports = __webpack_public_path__ + "img/img_banner.1206ed6c.png";